// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
  color: var(--ca-text-primary, #172033);
}

.breadcrumb {
  margin-top: 1.5rem;
  margin-left: 1.5rem;
}

.asset-capture-page {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 1.5rem;
  margin: 0 auto;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 1.25rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.875rem;
}

.breadcrumb-link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font: inherit;
  text-decoration: none;
  cursor: pointer;
}
.breadcrumb-link:hover {
  color: var(--ca-primary-dark, #0d2863);
  text-decoration: underline;
}
.breadcrumb-link:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 3px;
  border-radius: var(--ca-radius-sm, 6px);
}

.breadcrumb-link i {
  font-size: 1.25rem;
}

.breadcrumb-separator {
  color: var(--ca-text-muted, #8c96a8);
}

.breadcrumb-current {
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 500;
}

.breadcrumb-current i {
  font-size: 1.25rem;
}

.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.25rem;
  margin-bottom: 1.25rem;
}

.page-heading h1 {
  margin: 0 0 0.35rem;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.35rem, 2vw, 1.7rem);
  font-weight: 650;
  line-height: 1.3;
}

.page-heading p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
}

.btn-primary,
.btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 2.6rem;
  padding: 0.65rem 1rem;
  border-radius: var(--ca-radius-md, 8px);
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.25;
  white-space: nowrap;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}
.btn-primary:focus-visible,
.btn-secondary:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 2px;
  box-shadow: none;
}
.btn-primary:disabled,
.btn-secondary:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.btn-primary {
  border: 1px solid var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}
.btn-primary:hover:not(:disabled) {
  border-color: var(--ca-primary-dark, #0d2863);
  background: var(--ca-primary-dark, #0d2863);
  color: #fff;
}
.btn-primary:active:not(:disabled) {
  border-color: var(--ca-primary-darker, #041b38);
  background: var(--ca-primary-darker, #041b38);
}

.btn-secondary {
  border: 1px solid var(--ca-border, #dfe4ec);
  background: var(--ca-surface, #fff);
  color: var(--ca-primary, #0e2e80);
}
.btn-secondary:hover:not(:disabled) {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-hover, #f8faff);
  color: var(--ca-primary-dark, #0d2863);
}

.add-source-button {
  flex: 0 0 auto;
}

/* Empty state intentionally replaces all list controls when no system source exists. */
.empty-state {
  display: grid;
  min-height: min(70vh, 42rem);
  place-items: center;
  padding: 2rem 1rem;
}

.empty-state-content {
  width: min(100%, 42rem);
  text-align: center;
}

.empty-state-icon {
  display: grid;
  width: 4.25rem;
  height: 4.25rem;
  place-items: center;
  margin: 0 auto 1.25rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 1.25rem;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 2rem;
}

.empty-state h1 {
  margin: 0 0 0.65rem;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.35rem, 2.5vw, 1.75rem);
  font-weight: 650;
  line-height: 1.3;
}

.empty-state p {
  max-width: 35rem;
  margin: 0 auto 1.5rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.98rem;
  line-height: 1.65;
}

.empty-state-action {
  min-height: 2.85rem;
  padding-inline: 1.25rem;
}

/* Table/list surface */
.asset-list-card {
  min-width: 0;
  padding: 1.25rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.search-toolbar {
  display: grid;
  grid-template-columns: minmax(18rem, 1.6fr) minmax(13rem, 0.8fr);
  gap: 0.875rem;
  margin-bottom: 1.25rem;
}

.search-field {
  display: flex;
  min-width: 0;
  align-items: stretch;
}

.search-control {
  width: 100%;
  min-width: 0;
  min-height: 2.65rem;
  border: 1px solid var(--ca-input-border, #dfe4ec);
  border-radius: var(--ca-radius-md, 8px);
  background-color: var(--ca-input-bg, #fff);
  color: var(--ca-text-primary, #172033);
  font-size: 0.9rem;
}
.search-control:focus {
  border-color: var(--ca-input-focus, #2850ad);
  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.15);
  outline: 0;
}
.search-control::placeholder {
  color: var(--ca-text-muted, #8c96a8);
}

.search-field .search-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.search-submit {
  display: inline-grid;
  width: 2.8rem;
  flex: 0 0 2.8rem;
  place-items: center;
  border: 1px solid var(--ca-primary, #0e2e80);
  border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0;
  background: var(--ca-primary, #0e2e80);
  color: #fff;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.search-submit:hover {
  background: var(--ca-primary-dark, #0d2863);
}
.search-submit:focus-visible {
  position: relative;
  z-index: 1;
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 2px;
}

.table-region {
  min-width: 0;
  overflow-x: auto;
}

.inline-loading {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  min-height: 5rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
}

.inline-error {
  margin: 0.75rem 0;
  padding: 0.875rem 1rem;
  border: 1px solid var(--ca-danger, #dc3545);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-text-primary, #172033);
}

.no-results {
  display: flex;
  min-height: 11rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  padding: 1.5rem;
  color: var(--ca-text-tertiary, #6f7b91);
  text-align: center;
}
.no-results i {
  color: var(--ca-primary-light, #2850ad);
  font-size: 1.75rem;
}
.no-results p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
}

.list-footer {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

/* Add-source cards */
.options-page-header {
  margin-bottom: 1.5rem;
}

.source-options-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: stretch;
  gap: 1.25rem;
}

.tool-card {
  display: flex;
  min-width: 0;
  min-height: 19rem;
  flex-direction: column;
  align-items: flex-start;
  padding: 1.5rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}
.tool-card:hover {
  transform: translateY(-2px);
  border-color: var(--ca-border, #dfe4ec);
  box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08));
}

.card-icon {
  display: grid;
  width: 3.25rem;
  height: 3.25rem;
  place-items: center;
  margin-bottom: 1.1rem;
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.5rem;
}

.tool-title {
  margin: 0 0 0.65rem;
  color: var(--ca-text-primary, #172033);
  font-size: 1.1rem;
  font-weight: 650;
  line-height: 1.4;
}

.tool-description {
  flex: 1 1 auto;
  margin: 0 0 1.35rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
  line-height: 1.65;
  overflow-wrap: anywhere;
}

.btn-open {
  align-self: flex-start;
  min-width: 6.25rem;
}

.state-panel {
  display: flex;
  min-height: 55vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  text-align: center;
}
.state-panel > i {
  margin-bottom: 0.75rem;
  color: var(--ca-danger, #dc3545);
  font-size: 2rem;
}
.state-panel h1 {
  margin: 0 0 0.5rem;
  font-size: 1.4rem;
}
.state-panel p {
  margin: 0 0 1rem;
  color: var(--ca-text-secondary, #4b5870);
}

.loading-spinner {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  border: 3px solid var(--ca-border, #dfe4ec);
  border-top-color: var(--ca-primary, #0e2e80);
  border-radius: 50%;
  animation: asset-capture-spin 0.8s linear infinite;
}

.loading-spinner-sm {
  width: 1.1rem;
  height: 1.1rem;
  border-width: 2px;
}

.loading-state p {
  margin: 0.8rem 0 0;
}

/* Center the back button beneath the source option cards */
.back-to-sources-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 1.75rem auto 0;
  padding-bottom: 0.5rem;
}

.back-to-sources-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-width: 15rem;
  min-height: 2.75rem;
  padding: 0.7rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 600;
  white-space: nowrap;
  border-radius: var(--ca-radius-md, 8px);
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.back-to-sources-button i {
  font-size: 1.25rem;
  line-height: 1;
}

.back-to-sources-button:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 3px;
  box-shadow: none;
}

/* Responsive layout */
@media (max-width: 767.98px) {
  .back-to-sources-container {
    margin-top: 1.25rem;
  }
  .back-to-sources-button {
    width: 100%;
    max-width: 22rem;
    min-width: 0;
    white-space: normal;
  }
}
@keyframes asset-capture-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 991.98px) {
  .source-options-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .tool-card:last-child {
    grid-column: 1/-1;
  }
  .search-toolbar {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 767.98px) {
  .asset-capture-page {
    padding: 1rem;
  }
  .page-header {
    flex-direction: column;
    align-items: stretch;
  }
  .add-source-button {
    align-self: flex-start;
  }
  .asset-list-card {
    padding: 0.875rem;
  }
  .source-options-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .tool-card:last-child {
    grid-column: auto;
  }
  .tool-card {
    min-height: auto;
  }
  .list-footer {
    flex-direction: column;
    align-items: stretch;
  }
  .back-button {
    align-self: flex-start;
  }
  .list-footer app-pagination {
    max-width: 100%;
    align-self: flex-end;
  }
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/shared-workflows/system-asset-capture/system-asset-capture.component.scss"],"names":[],"mappings":"AACA;EACE,cAAA;EACA,YAAA;EACA,sCAAA;AAAF;;AAGA;EACE,kBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;AAAF;AAEE;EACE,sCAAA;EACA,0BAAA;AAAJ;AAGE;EACE,0CAAA;EACA,mBAAA;EACA,uCAAA;AADJ;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,oCAAA;AAFF;;AAKA;EAEE,wCAAA;EACA,gBAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;AAHF;;AAMA;EACE,mBAAA;EACA,sCAAA;EACA,sCAAA;EACA,gBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,SAAA;EACA,wCAAA;EACA,iBAAA;AAHF;;AAMA;;EAEE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,uCAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,6GAAA;AAHF;AAKE;;EACE,0CAAA;EACA,mBAAA;EACA,gBAAA;AAFJ;AAKE;;EACE,mBAAA;EACA,YAAA;AAFJ;;AAMA;EACE,4CAAA;EACA,sCAAA;EACA,WAAA;AAHF;AAKE;EACE,6CAAA;EACA,2CAAA;EACA,WAAA;AAHJ;AAME;EACE,+CAAA;EACA,6CAAA;AAJJ;;AAQA;EACE,2CAAA;EACA,mCAAA;EACA,iCAAA;AALF;AAOE;EACE,wCAAA;EACA,4CAAA;EACA,sCAAA;AALJ;;AASA;EACE,cAAA;AANF;;AASA,uFAAA;AACA;EACE,aAAA;EACA,4BAAA;EACA,mBAAA;EACA,kBAAA;AANF;;AASA;EACE,uBAAA;EACA,kBAAA;AANF;;AASA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,iDAAA;EACA,sBAAA;EACA,6CAAA;EACA,iCAAA;EACA,eAAA;AANF;;AASA;EACE,mBAAA;EACA,sCAAA;EACA,yCAAA;EACA,gBAAA;EACA,gBAAA;AANF;;AASA;EACE,gBAAA;EACA,qBAAA;EACA,wCAAA;EACA,kBAAA;EACA,iBAAA;AANF;;AASA;EACE,mBAAA;EACA,uBAAA;AANF;;AASA,uBAAA;AACA;EACE,YAAA;EACA,gBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;AANF;;AASA;EACE,aAAA;EACA,gEAAA;EACA,aAAA;EACA,sBAAA;AANF;;AASA;EACE,aAAA;EACA,YAAA;EACA,oBAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iDAAA;EACA,uCAAA;EACA,0CAAA;EACA,sCAAA;EACA,iBAAA;AANF;AAQE;EACE,4CAAA;EACA,gDAAA;EACA,UAAA;AANJ;AASE;EACE,oCAAA;AAPJ;;AAWA;EACE,0BAAA;EACA,6BAAA;AARF;;AAWA;EACE,oBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,4CAAA;EACA,oEAAA;EACA,sCAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,uCAAA;AARF;AAUE;EACE,2CAAA;AARJ;AAWE;EACE,kBAAA;EACA,UAAA;EACA,0CAAA;EACA,mBAAA;AATJ;;AAaA;EACE,YAAA;EACA,gBAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,wCAAA;EACA,iBAAA;AAVF;;AAaA;EACE,iBAAA;EACA,sBAAA;EACA,2CAAA;EACA,uCAAA;EACA,wCAAA;EACA,sCAAA;AAVF;;AAaA;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,uCAAA;EACA,kBAAA;AAVF;AAYE;EACE,uCAAA;EACA,kBAAA;AAVJ;AAaE;EACE,SAAA;EACA,wCAAA;AAXJ;;AAeA;EACE,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,qDAAA;AAZF;;AAeA,qBAAA;AACA;EACE,qBAAA;AAZF;;AAeA;EACE,aAAA;EACA,gDAAA;EACA,oBAAA;EACA,YAAA;AAZF;;AAeA;EACE,aAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;EACA,6EAAA;AAZF;AAcE;EACE,2BAAA;EACA,uCAAA;EACA,iEAAA;AAZJ;;AAgBA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,uCAAA;EACA,6CAAA;EACA,iCAAA;EACA,iBAAA;AAbF;;AAgBA;EACE,mBAAA;EACA,sCAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,cAAA;EACA,mBAAA;EACA,wCAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;AAbF;;AAgBA;EACE,sBAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAbF;AAeE;EACE,sBAAA;EACA,gCAAA;EACA,eAAA;AAbJ;AAgBE;EACE,kBAAA;EACA,iBAAA;AAdJ;AAiBE;EACE,gBAAA;EACA,wCAAA;AAfJ;;AAmBA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,4CAAA;EACA,kBAAA;EACA,kDAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;EACE,kBAAA;AAhBF;;AAoBA,2DAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,WAAA;EACA,sBAAA;EACA,sBAAA;AAlBF;;AAqBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EAEA,gBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,iBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,uCAAA;EAEA,uFACE;AAvBJ;;AA4BA;EACE,kBAAA;EACA,cAAA;AAzBF;;AA4BA;EACE,0CAAA;EACA,mBAAA;EACA,gBAAA;AAzBF;;AA4BA,sBAAA;AACA;EACE;IACE,mBAAA;EAzBF;EA4BA;IACE,WAAA;IACA,gBAAA;IACA,YAAA;IACA,mBAAA;EA1BF;AACF;AA6BA;EACE;IAAK,yBAAA;EA1BL;AACF;AA4BA;EACE;IACE,gDAAA;EA1BF;EA6BA;IACE,iBAAA;EA3BF;EA8BA;IACE,qCAAA;EA5BF;AACF;AA+BA;EACE;IACE,aAAA;EA7BF;EAgCA;IACE,sBAAA;IACA,oBAAA;EA9BF;EAiCA;IACE,sBAAA;EA/BF;EAkCA;IACE,iBAAA;EAhCF;EAmCA;IACE,qCAAA;EAjCF;EAoCA;IACE,iBAAA;EAlCF;EAqCA;IACE,gBAAA;EAnCF;EAsCA;IACE,sBAAA;IACA,oBAAA;EApCF;EAuCA;IACE,sBAAA;EArCF;EAwCA;IACE,eAAA;IACA,oBAAA;EAtCF;AACF;AAyCA;EACE;;;IAGE,qCAAA;IACA,uCAAA;IACA,gCAAA;IACA,sCAAA;EAvCF;AACF","sourcesContent":["\n:host {\n  display: block;\n  min-width: 0;\n  color: var(--ca-text-primary, #172033);\n}\n\n.breadcrumb {\n  margin-top: 1.5rem;\n  margin-left: 1.5rem;\n}\n\n.asset-capture-page {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  padding: 1.5rem;\n  margin: 0 auto;\n}\n\n.breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 0 1.25rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.875rem;\n}\n\n.breadcrumb-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--ca-primary, #0e2e80);\n  font: inherit;\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    color: var(--ca-primary-dark, #0d2863);\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    outline: 3px solid rgba(40, 80, 173, 0.25);\n    outline-offset: 3px;\n    border-radius: var(--ca-radius-sm, 6px);\n  }\n}\n\n.breadcrumb-link i {\n  font-size: 1.25rem;\n}\n\n.breadcrumb-separator {\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.breadcrumb-current {\n\n  color: var(--ca-text-secondary, #4b5870);\n  font-weight: 500;\n}\n\n.breadcrumb-current i {\n  font-size: 1.25rem;\n}\n\n.page-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1.25rem;\n  margin-bottom: 1.25rem;\n}\n\n.page-heading h1 {\n  margin: 0 0 0.35rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: clamp(1.35rem, 2vw, 1.7rem);\n  font-weight: 650;\n  line-height: 1.3;\n}\n\n.page-heading p {\n  margin: 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.9rem;\n}\n\n.btn-primary,\n.btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  min-height: 2.6rem;\n  padding: 0.65rem 1rem;\n  border-radius: var(--ca-radius-md, 8px);\n  font-size: 0.9rem;\n  font-weight: 600;\n  line-height: 1.25;\n  white-space: nowrap;\n  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;\n\n  &:focus-visible {\n    outline: 3px solid rgba(40, 80, 173, 0.25);\n    outline-offset: 2px;\n    box-shadow: none;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n}\n\n.btn-primary {\n  border: 1px solid var(--ca-primary, #0e2e80);\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n\n  &:hover:not(:disabled) {\n    border-color: var(--ca-primary-dark, #0d2863);\n    background: var(--ca-primary-dark, #0d2863);\n    color: #fff;\n  }\n\n  &:active:not(:disabled) {\n    border-color: var(--ca-primary-darker, #041b38);\n    background: var(--ca-primary-darker, #041b38);\n  }\n}\n\n.btn-secondary {\n  border: 1px solid var(--ca-border, #dfe4ec);\n  background: var(--ca-surface, #fff);\n  color: var(--ca-primary, #0e2e80);\n\n  &:hover:not(:disabled) {\n    border-color: var(--ca-primary, #0e2e80);\n    background: var(--ca-surface-hover, #f8faff);\n    color: var(--ca-primary-dark, #0d2863);\n  }\n}\n\n.add-source-button {\n  flex: 0 0 auto;\n}\n\n/* Empty state intentionally replaces all list controls when no system source exists. */\n.empty-state {\n  display: grid;\n  min-height: min(70vh, 42rem);\n  place-items: center;\n  padding: 2rem 1rem;\n}\n\n.empty-state-content {\n  width: min(100%, 42rem);\n  text-align: center;\n}\n\n.empty-state-icon {\n  display: grid;\n  width: 4.25rem;\n  height: 4.25rem;\n  place-items: center;\n  margin: 0 auto 1.25rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 1.25rem;\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 2rem;\n}\n\n.empty-state h1 {\n  margin: 0 0 0.65rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: clamp(1.35rem, 2.5vw, 1.75rem);\n  font-weight: 650;\n  line-height: 1.3;\n}\n\n.empty-state p {\n  max-width: 35rem;\n  margin: 0 auto 1.5rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.98rem;\n  line-height: 1.65;\n}\n\n.empty-state-action {\n  min-height: 2.85rem;\n  padding-inline: 1.25rem;\n}\n\n/* Table/list surface */\n.asset-list-card {\n  min-width: 0;\n  padding: 1.25rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n}\n\n.search-toolbar {\n  display: grid;\n  grid-template-columns: minmax(18rem, 1.6fr) minmax(13rem, 0.8fr);\n  gap: 0.875rem;\n  margin-bottom: 1.25rem;\n}\n\n.search-field {\n  display: flex;\n  min-width: 0;\n  align-items: stretch;\n}\n\n.search-control {\n  width: 100%;\n  min-width: 0;\n  min-height: 2.65rem;\n  border: 1px solid var(--ca-input-border, #dfe4ec);\n  border-radius: var(--ca-radius-md, 8px);\n  background-color: var(--ca-input-bg, #fff);\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.9rem;\n\n  &:focus {\n    border-color: var(--ca-input-focus, #2850ad);\n    box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.15);\n    outline: 0;\n  }\n\n  &::placeholder {\n    color: var(--ca-text-muted, #8c96a8);\n  }\n}\n\n.search-field .search-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.search-submit {\n  display: inline-grid;\n  width: 2.8rem;\n  flex: 0 0 2.8rem;\n  place-items: center;\n  border: 1px solid var(--ca-primary, #0e2e80);\n  border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0;\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background: var(--ca-primary-dark, #0d2863);\n  }\n\n  &:focus-visible {\n    position: relative;\n    z-index: 1;\n    outline: 3px solid rgba(40, 80, 173, 0.25);\n    outline-offset: 2px;\n  }\n}\n\n.table-region {\n  min-width: 0;\n  overflow-x: auto;\n}\n\n.inline-loading {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  min-height: 5rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.9rem;\n}\n\n.inline-error {\n  margin: 0.75rem 0;\n  padding: 0.875rem 1rem;\n  border: 1px solid var(--ca-danger, #dc3545);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-danger-bg, #fdecef);\n  color: var(--ca-text-primary, #172033);\n}\n\n.no-results {\n  display: flex;\n  min-height: 11rem;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.65rem;\n  padding: 1.5rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  text-align: center;\n\n  i {\n    color: var(--ca-primary-light, #2850ad);\n    font-size: 1.75rem;\n  }\n\n  p {\n    margin: 0;\n    color: var(--ca-text-secondary, #4b5870);\n  }\n}\n\n.list-footer {\n  display: flex;\n  align-items:flex-end;\n  justify-content:flex-end;\n  gap: 1rem;\n  margin-top: 1.25rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n/* Add-source cards */\n.options-page-header {\n  margin-bottom: 1.5rem;\n}\n\n.source-options-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  align-items: stretch;\n  gap: 1.25rem;\n}\n\n.tool-card {\n  display: flex;\n  min-width: 0;\n  min-height: 19rem;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 1.5rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n\n  &:hover {\n    transform: translateY(-2px);\n    border-color: var(--ca-border, #dfe4ec);\n    box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08));\n  }\n}\n\n.card-icon {\n  display: grid;\n  width: 3.25rem;\n  height: 3.25rem;\n  place-items: center;\n  margin-bottom: 1.1rem;\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.5rem;\n}\n\n.tool-title {\n  margin: 0 0 0.65rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1.1rem;\n  font-weight: 650;\n  line-height: 1.4;\n}\n\n.tool-description {\n  flex: 1 1 auto;\n  margin: 0 0 1.35rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.9rem;\n  line-height: 1.65;\n  overflow-wrap: anywhere;\n}\n\n.btn-open {\n  align-self: flex-start;\n  min-width: 6.25rem;\n}\n\n.state-panel {\n  display: flex;\n  min-height: 55vh;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 1rem;\n  text-align: center;\n\n  > i {\n    margin-bottom: 0.75rem;\n    color: var(--ca-danger, #dc3545);\n    font-size: 2rem;\n  }\n\n  h1 {\n    margin: 0 0 0.5rem;\n    font-size: 1.4rem;\n  }\n\n  p {\n    margin: 0 0 1rem;\n    color: var(--ca-text-secondary, #4b5870);\n  }\n}\n\n.loading-spinner {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  border: 3px solid var(--ca-border, #dfe4ec);\n  border-top-color: var(--ca-primary, #0e2e80);\n  border-radius: 50%;\n  animation: asset-capture-spin 0.8s linear infinite;\n}\n\n.loading-spinner-sm {\n  width: 1.1rem;\n  height: 1.1rem;\n  border-width: 2px;\n}\n\n.loading-state p {\n  margin: 0.8rem 0 0;\n}\n\n\n/* Center the back button beneath the source option cards */\n.back-to-sources-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  width: 100%;\n  margin: 1.75rem auto 0;\n  padding-bottom: 0.5rem;\n}\n\n.back-to-sources-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n\n  min-width: 15rem;\n  min-height: 2.75rem;\n  padding: 0.7rem 1.25rem;\n\n  font-size: 0.9rem;\n  font-weight: 600;\n  white-space: nowrap;\n\n  border-radius: var(--ca-radius-md, 8px);\n\n  transition:\n    background-color 0.15s ease,\n    border-color 0.15s ease,\n    box-shadow 0.15s ease;\n}\n\n.back-to-sources-button i {\n  font-size: 1.25rem;\n  line-height: 1;\n}\n\n.back-to-sources-button:focus-visible {\n  outline: 3px solid rgba(40, 80, 173, 0.25);\n  outline-offset: 3px;\n  box-shadow: none;\n}\n\n/* Responsive layout */\n@media (max-width: 767.98px) {\n  .back-to-sources-container {\n    margin-top: 1.25rem;\n  }\n\n  .back-to-sources-button {\n    width: 100%;\n    max-width: 22rem;\n    min-width: 0;\n    white-space: normal;\n  }\n}\n\n@keyframes asset-capture-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 991.98px) {\n  .source-options-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .tool-card:last-child {\n    grid-column: 1 / -1;\n  }\n\n  .search-toolbar {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n@media (max-width: 767.98px) {\n  .asset-capture-page {\n    padding: 1rem;\n  }\n\n  .page-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .add-source-button {\n    align-self: flex-start;\n  }\n\n  .asset-list-card {\n    padding: 0.875rem;\n  }\n\n  .source-options-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .tool-card:last-child {\n    grid-column: auto;\n  }\n\n  .tool-card {\n    min-height: auto;\n  }\n\n  .list-footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .back-button {\n    align-self: flex-start;\n  }\n\n  .list-footer app-pagination {\n    max-width: 100%;\n    align-self: flex-end;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    scroll-behavior: auto !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
